import { VariableType } from 'json-to-graphql-query';

import { Resource } from './resource';

/**
 * Resource planów finansowych
 *
 * @export
 * @class FinancialPlanResource
 * @extends {Resource}
 */
export class FinancialPlanResource extends Resource {
  /**
   * Pobranie planu finansowego
   *
   * @param {*} variables
   * @returns {Promise<Array<{ name: string; amount: number }>>}
   * @memberof FinancialPlanResource
   */
  public getFinancialPlan(variables: any): Promise<Array<{ name: string; amount: number }>> {
    const query = this.prepareOptions({
      query: {
        __variables: {
          procedureId: 'Int!',
          startDate: 'DateScalar!',
          endDate: 'DateScalar!',
          planType: 'FinancialPlanType!',
          isUkraine: 'Boolean'
        },
        financialPlanGet: {
          __args: {
            procedureId: new VariableType('procedureId'),
            startDate: new VariableType('startDate'),
            endDate: new VariableType('endDate'),
            planType: new VariableType('planType'),
            isUkraine: new VariableType('isUkraine')
          },
          name: true,
          amount: true
        }
      }
    });
    return this.query({ query, variables }, 'financialPlanGet');
  }

  /**
   * Przesyła plan do MDOK
   *
   * @param {*} variables
   * @returns {Promise<boolean>}
   * @memberof FinancialPlanResource
   */
  public sendToMdok(variables: any): Promise<boolean> {
    const mutation = this.prepareOptions({
      mutation: {
        __variables: {
          procedureId: 'Int!',
          startDate: 'DateScalar!',
          endDate: 'DateScalar!',
          planType: 'FinancialPlanType!',
          records: '[FinancialPlanRecordInput!]!',
          isUkraine: 'Boolean'
        },
        financialPlanSendToMdok: {
          __args: {
            procedureId: new VariableType('procedureId'),
            startDate: new VariableType('startDate'),
            endDate: new VariableType('endDate'),
            planType: new VariableType('planType'),
            records: new VariableType('records'),
            isUkraine: new VariableType('isUkraine')
          }
        }
      }
    });
    return this.mutation({ mutation, variables }, 'financialPlanSendToMdok');
  }
}

export const financialPlanResource = new FinancialPlanResource();
